import types from '../types/calendar'
import {TIMESLOT, RENT} from '../../../endpoints'
import {apiPrivate} from '../../../api'
import simpleSnackbarActions from '../../../common/actions/simpleSnackbar'
import {push} from 'react-router-redux'
import {endpoint as endpointText} from '../../../common/text'
import moment from '../../../common/moment'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class calendar {

  static selectDates(dateStart, dateEnd) {
    return function(dispatch) {
      dispatch({
        type: types.SELECT_DATES,
        payload: {
          dateStart,
          dateEnd,
        },
      })
      dispatch(calendar.getTimeslots(dateStart, 'start'))
      dispatch(calendar.getTimeslots(dateEnd, 'end'))
    }
  }

  static getUnavailableDates() {
    return function(dispatch, getState) {

      const item = getState().ui.rentV2.start.get('item')

      dispatch({type: types.GET_UNAVAILABLE_DATES})

      const params = {startDate: moment().format('X'), daysAmount: 365}

      return Promise.all([
        apiPrivate.get(TIMESLOT + '/timeSlot/occupiedDates?daysOnwards=90'),
        apiPrivate.get(RENT + '/object/' + item.get('ID') + '/availability', {params}),
      ])
        .then(results => {

          const busyDates = results[0].data.description.map(d => moment.utc(d).utcOffset(moment().utcOffset(), true))

          const periodDisable = results[1].data.description.rentedPeriod
          const occupiedDays = results[1].data.description.occupiedDates

          const itemUnavailableDates = []

          if (periodDisable) {
            periodDisable.forEach(period => {
              const startDate = moment.utc(period.StartDate).utcOffset(moment().utcOffset(), true)
              let currentDate = moment.utc(period.EndDate).utcOffset(moment().utcOffset(), true)
              while (currentDate.isSameOrAfter(startDate)) {
                itemUnavailableDates.push(currentDate.clone())
                currentDate.subtract(1, 'day')
              }
            })
          }

          occupiedDays.forEach(occupiedDay => {
            const date = moment.utc(occupiedDay).utcOffset(moment().utcOffset(), true)
            itemUnavailableDates.push(date)
          })

          const unavailableDates = busyDates.concat(itemUnavailableDates)

          dispatch(calendar.getUnavailableDatesSuccess(unavailableDates))
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(calendar.getUnavailableDatesFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(calendar.getUnavailableDatesFail(message))
          dispatch(simpleSnackbarActions.showMessage(message))
        })
    }
  }

  static getUnavailableDatesSuccess(data) {
    return {
      type: types.GET_UNAVAILABLE_DATES_SUCCESS,
      payload: {
        dates: data,
      },
    }
  }

  static getUnavailableDatesFail(error) {
    return {
      type: types.GET_UNAVAILABLE_DATES_FAIL,
      payload: {
        error,
      },
    }
  }

  static selectTimeslot(timeslot, type) {
    return {
      type: types.SELECT_TIMESLOT,
      payload: {
        timeslot,
        type,
      },
    }
  }

  static getTimeslots(date, type) {
    return function(dispatch, getState) {

      const lastTimeslotFetchID = (new Date()).getMilliseconds()
      dispatch({
        type: types.GET_TIMESLOTS,
        payload: {
          lastTimeslotFetchID,
        },
      })

      apiPrivate.get(TIMESLOT + '/timeSlot?date=' + date.format('X'))
        .then(response => {
          // if (lastTimeslotFetchID === getState().ui.rentV2.timeslot.get('lastTimeslotFetchID')) {
          dispatch(calendar.getTimeslotsSuccess(response.data.description, type))
          // }
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(calendar.getTimeslotsFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(calendar.getTimeslotsFail(message))
          dispatch(simpleSnackbarActions.showMessage(message))
        })
    }
  }

  static getTimeslotsSuccess(data, type) {
    return {
      type: types.GET_TIMESLOTS_SUCCESS,
      payload: {
        timeslots: data,
        type,
      },
    }
  }

  static getTimeslotsFail(error) {
    return {
      type: types.GET_TIMESLOTS_FAIL,
      payload: {
        error,
      },
    }
  }

  static modifyRent() {
    return function(dispatch, getState) {

      const state = getState().ui.rentV2.calendar

      const rent = getState().ui.rentV2.start.getIn(['rent', 'ID'])
      const timeslotStart = state.get('timeslotStart')
      const dateEnd = state.get('dateEnd')
      const timeslotEnd = state.get('timeslotEnd')
      const dateStart = state.get('dateStart')
      const address = state.get('address')

      if (timeslotStart === 0 || timeslotEnd === 0 || dateStart === null || dateEnd === null) {
        dispatch(calendar.modifyRentFail(''))
        return Promise.reject(null)
      }

      dispatch({type: types.MODIFY_RENT})

      const data = new FormData()
      data.append('time_slot_start_date', timeslotStart)
      data.append('start_date', dateStart.format('X'))
      data.append('time_slot_end_date', timeslotEnd)
      data.append('end_date', dateEnd.format('X'))
      if (address !== 0) data.append('address', address)

      return apiPrivate.put(RENT + '/rent/' + rent, data)
        .then(response => {
          dispatch(calendar.modifyRentSuccess(response.data.description))
          return true
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(calendar.modifyRentFail(message))
              return false
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(calendar.modifyRentFail(message))
          dispatch(simpleSnackbarActions.showMessage(message))
          return false
        })
    }
  }

  static modifyRentSuccess(rent) {
    return {
      type: types.MODIFY_RENT_SUCCESS,
      payload: {
        rent,
      },
    }
  }

  static modifyRentFail(error) {
    return {
      type: types.MODIFY_RENT_FAIL,
      payload: {
        error,
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/sections/rentV2/actions/calendar.js